import * as React from 'react';
import { useDebouncedValue } from '../../hooks/useDebouncedValue';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Input } from '@mui/material';
import { Avatar } from '@boringer-avatars/react';
import {
  AvatarContainer,
  Frame12841,
  SelectInput,
  StyledInput,
  StyledSelect,
} from './style';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

export default function RoundedDropDown({
  menuItems,
  defaultValue = '',
  value: propValue,
  search = false,
  selectedIndex,
  fullWidth = false,
  type,
  emptyLabel,
}) {
  const [value, setValue] = React.useState(propValue || defaultValue);
  const [searchTerm, setSearchTerm] = React.useState('');
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 250);
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    if (propValue !== undefined) {
      setValue(propValue);
    } else {
      setValue(defaultValue);
    }
  }, [propValue, defaultValue, location.pathname]);

  const handleMenuSelect = (menuItem) => {
    setSearchTerm('');
    setValue(menuItem);
    setOpen(false);
    selectedIndex(type, menuItem);
  };

  return (
    <FormControl fullWidth={fullWidth}>
      <StyledSelect
        MenuProps={{
          PaperProps: {
            sx: {
              padding: '5px',
            },
          },
          fontWeight: '400',
          fontSize: '13px',
        }}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        value={value}
        displayEmpty
        input={
          <SelectInput
            style={{ color: '#7B7382', fontSize: '13px', padding: '4px 8px' }}
            disableUnderline={true}
          />
        }
      >
        {search && (
          <StyledInput
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search...."
            disableUnderline={true}
            onClickCapture={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          />
        )}
        {(() => {
          const emptyOptionLabel = emptyLabel ?? (type === 'documentType' ? 'Task Type' : capitalizeFirstLetter(type || ''));
          if (!emptyOptionLabel) return null;
          return (
            <MenuItem value={''} onClick={() => handleMenuSelect('')}>
              {emptyOptionLabel}
            </MenuItem>
          );
        })()}
        {menuItems
          ?.filter((item) =>
            item?.toLowerCase().includes(debouncedSearchTerm.toLowerCase()),
          )
          .map((filteredItem) => (
            <MenuItem
              key={filteredItem}
              value={filteredItem}
              onClick={() => handleMenuSelect(filteredItem)}
            >
              {filteredItem}
            </MenuItem>
          ))}
      </StyledSelect>
    </FormControl>
  );
}

const capitalizeFirstLetter = (str) =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
